import { Content, ContentImageFields } from '@beat-venues/common-types';

export const mockContentImageBase: Content<'contentImage', ContentImageFields> =
    {
        sys: {
            id: '1kAkwZHa300QGSSWGO7rNp',
            contentType: {
                sys: {
                    id: 'contentImage',
                },
            },
        },
        fields: {
            image: {
                sys: {
                    id: '1kAkwZHa300QGSSWGO7rNp',
                },
                fields: {
                    file: {
                        fileName: 'JustinBieber.jpg',
                        url: 'https://placehold.co/1534x894',
                        details: {
                            size: 1234,
                            image: { width: 1234, height: 894 },
                        },
                        contentType: 'image/jpeg',
                    },
                },
            },
            altText: 'Justin Bieber',
        },
    };

export const mockContentImageWithCaption: Content<
    'contentImage',
    ContentImageFields
> = {
    ...mockContentImageBase,
    fields: {
        ...mockContentImageBase.fields,
        caption: 'Justin Bieber',
    },
};

export const mockContentImageWithCreditText: Content<
    'contentImage',
    ContentImageFields
> = {
    ...mockContentImageBase,
    fields: {
        ...mockContentImageBase.fields,
        creditText: 'Justin Bieber credit text',
    },
};

export const mockContentImageFull: Content<'contentImage', ContentImageFields> =
    {
        ...mockContentImageBase,
        fields: {
            ...mockContentImageBase.fields,
            ...mockContentImageWithCaption.fields,
            ...mockContentImageWithCreditText.fields,
        },
    };
